const contentElements = document.querySelectorAll(
  "accordion-tab .accordion__content"
);

contentElements.forEach((contentElement) => {
  const delimiterIndex = contentElement.innerHTML.indexOf("<!-- split -->");
  if (delimiterIndex !== -1) {
    // Extract content before and after the delimiter
    const contentBeforeDelimiter = contentElement.innerHTML.substring(
      0,
      delimiterIndex
    );
    const contentAfterDelimiter =
      contentElement.innerHTML.substring(delimiterIndex);

    // Initially, show content before delimiter and hide content after delimiter
    contentElement.innerHTML = contentBeforeDelimiter;

    // Add "Show More" button to toggle visibility of content after delimiter
    const showMoreBtn = document.createElement("button");
    showMoreBtn.textContent = "Show More";
    showMoreBtn.classList.add("show-more-btn");
    showMoreBtn.addEventListener("click", function () {
      const buttonPosition =
        showMoreBtn.getBoundingClientRect().top + window.scrollY;
      if (contentElement.classList.contains("expanded")) {

        contentElement.innerHTML = contentBeforeDelimiter;
        this.textContent = "Show More";

        // Scroll back to the position of the "Show More" button
        const topPosition =
          showMoreBtn.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top: topPosition, behavior: "smooth" });
      } else {

        contentElement.innerHTML =
          contentBeforeDelimiter + contentAfterDelimiter;
        this.textContent = "Show Less";
      }
      contentElement.classList.toggle("expanded");
    });

    contentElement.parentNode.appendChild(showMoreBtn);
  }
});

class VariantIngredients extends HTMLElement {
    constructor() {
      super();
      this.ingredientsEl = null;
      this.variantDataEl = null;
      this.defaultProductIngredients = '';
      this.ingredientMap = [];
    }

    connectedCallback() {
      this.ingredientsEl = this.querySelector(".intergerationmetafield");
      this.variantDataEl = this.querySelector("#variant-ingredients-data");

      if (!this.ingredientsEl || !this.variantDataEl) return;

      this.defaultProductIngredients = this.ingredientsEl.innerHTML.trim();
      try {
        this.ingredientMap = JSON.parse(this.variantDataEl.dataset.ingredients);
      } catch (e) {
        console.error("Invalid ingredients JSON", e);
      }

      document.addEventListener("variant:change", this.updateIngredients.bind(this));
    }

    updateIngredients(event) {
      const variantId = event.detail.variant.id;
      const matched = this.ingredientMap.find(v => v.id == variantId);

      if (matched && matched.ingredients) {
        this.ingredientsEl.innerHTML = matched.ingredients;
      } else {
        this.ingredientsEl.innerHTML = this.defaultProductIngredients || "";
      }
    }
  }

  customElements.define('variant-ingredients', VariantIngredients);
